import { Injectable } from '@angular/core';
import { BilledRequestStrategy } from './billed-request-strategy.interface';

@Injectable({
  providedIn: 'root'
})
export class BilledRequestService {

  private currentStrategy: BilledRequestStrategy | null = null;

  constructor() { }

    useStrategy(strategy: BilledRequestStrategy): void {
      this.currentStrategy = strategy;
    }

    async initializePayment(config: any): Promise<boolean> {
      if (!this.currentStrategy) {
        throw new Error('No se ha seleccionado una estrategia de pago.');
      }
      return await this.currentStrategy.initialize(config);
    }

    async processPayment(metadata: any): Promise<any> {
      if (!this.currentStrategy) {
        throw new Error('No se ha seleccionado una estrategia de pago.');
      }
      return await this.currentStrategy.processBilled(metadata);
    }
}
